import React from 'react';
import { Box, Typography } from '@mui/material';
import { APP_VERSION } from '../config/version';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        textAlign: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Showtime Kayaking Backlot Admin Portal v{APP_VERSION}
      </Typography>
    </Box>
  );
};

export default Footer;


